import { createSlice } from '@reduxjs/toolkit';

import { CourseTypes, INITIAL_LIST_PARAMS } from 'config';
import { CourseState } from '../../types/course';

const initialState: CourseState = {
  isLoading: false,
  courseList: {},
  allCourses: [],
  courseListParams: { ...INITIAL_LIST_PARAMS, course_type: CourseTypes.CHALLENGE },
};

const slice = createSlice({
  name: 'challenge',
  initialState,
  reducers: {
    challengeStartLoading(state) {
      state.isLoading = true;
    },

    getAllCoursesSuccess(state, action) {
      state.allCourses = action.payload;
    },

    challengeHasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    challengeResetError(state) {
      state.error = undefined;
    },

    getChallengeListSuccess(state, action) {
      state.isLoading = false;
      state.courseList = action.payload;
    },

    getChallengeSuccess(state, action) {
      state.isLoading = false;
      state.course = action.payload;
    },

    setChallengeListParams(state, action) {
      state.courseListParams = action.payload;
    },

    clearChallenge(state) {
      state.course = undefined;
    },

    clearChallengeList(state) {
      state.courseList = {};
    },

    clearChallengeParameters(state) {
      state.courseListParams = {};
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  challengeStartLoading,
  challengeHasError,
  challengeResetError,
  getChallengeListSuccess,
  getChallengeSuccess,
  getAllCoursesSuccess,
  setChallengeListParams,
  clearChallenge,
  clearChallengeParameters,
  clearChallengeList,
} = slice.actions;
